module.exports = __webpack_public_path__ + "img/Icon-PulsedAPC@2x.e7731b16.png";